/**
 * Em dash shown for empty display values, the platform-wide convention for
 * "no data" in cells, summary fields, and detail lists.
 */
export const VALUE_PLACEHOLDER = '—'

/**
 * True for a nullish or blank-string value — render {@link VALUE_PLACEHOLDER}
 * for these. `0` and `false` are values a field can hold, so neither is empty.
 */
export function isEmptyValue(value: unknown): boolean {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '')
  )
}
